import React from 'react';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';

import { useTheme } from '../theme';
import { ThemedAuthenticationLayout } from './ThemedAuthenticationLayout';
import CssBaseline from '@material-ui/core/CssBaseline';

export const AuthenticationLayout = props => {
    const { theme } = useTheme();

    return (
        <ThemeProvider theme={createTheme(theme)}>
            <CssBaseline />
            <ThemedAuthenticationLayout {...props} />
        </ThemeProvider>
    );
};
